import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Reveal } from './ui/Reveal';
import { BookOpen, Award } from 'lucide-react';
export function EducationSection() {
  return <Section id="education" variant="charcoal" data-id="element-176">
      <SectionHeader title="Credentials" subtitle="Education & Training" data-id="element-177" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-178">
        <Reveal data-id="element-179">
          <div className="space-y-6" data-id="element-180">
            <h3 className="text-2xl text-white font-heading uppercase border-b border-gold-500/30 pb-2 mb-6" data-id="element-181">
              Academic Degrees
            </h3>
            {[{
            degree: 'M.S. National Resource Strategy',
            school: 'National Defense University'
          }, {
            degree: 'M.S. Materiel Acquisition Management',
            school: 'Florida Institute of Technology'
          }, {
            degree: 'B.S. Business Administration',
            school: 'Emporia State University'
          }].map((edu, i) => <div key={i} className="flex gap-4" data-id="element-182">
                <div className="mt-1" data-id="element-183">
                  <BookOpen className="w-5 h-5 text-gold-500" data-id="element-184" />
                </div>
                <div data-id="element-185">
                  <h4 className="text-lg font-bold text-white" data-id="element-186">{edu.degree}</h4>
                  <p className="text-slate-400" data-id="element-187">{edu.school}</p>
                </div>
              </div>)}
          </div>
        </Reveal>

        <Reveal delay={200} data-id="element-188">
          <div className="space-y-6" data-id="element-189">
            <h3 className="text-2xl text-white font-heading uppercase border-b border-gold-500/30 pb-2 mb-6" data-id="element-190">
              Certifications
            </h3>
            <ul className="space-y-4" data-id="element-191">
              {['DAWIA Level III Certification', 'Joint Professional Military Education Phase II', 'Life Cycle Logistics, Level III — Defense Acquisition Workforce Improvement Act (DAWIA)'].map((cert, i) => <li key={i} className="flex items-center bg-navy-900 p-4 border-l-2 border-gold-500" data-id="element-192">
                  <Award className="w-5 h-5 text-gold-500 mr-3" data-id="element-193" />
                  <span className="text-slate-300 font-medium" data-id="element-194">{cert}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </Section>;
}